import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AuthNoticeService } from '../../../../../app/core/auth/auth-notice/auth-notice.service';
import { SplashScreenService } from '../../../../../app/core/_base/layout';
import { AuthService } from '../../../../core/auth/_services/auth.service';
import { environment } from '../../../../../environments';

@Component({
  // selector: 'kt-signout',
  selector: 'app-logout-callback',
  templateUrl: './logout-callback.component.html',
  styleUrls: ['./logout-callback.component.scss']
})
export class LogoutCallbackComponent implements OnInit, OnDestroy {
  loading = false;
  private unsubscribe: Subject<any>;
  loginError: string;
  today: number = Date.now();
  headerLogo: string;
  backgroundPage: string;

  constructor(
    private authNoticeService: AuthNoticeService,
    private router: Router,
    private splahScreenService: SplashScreenService,
    private _auth: AuthService
  ) {
    this.headerLogo = environment.assets.brandLogo;
	  this.backgroundPage = environment.assets.logoutCallbackBackground;
  }

  ngOnInit(): void {
    this._auth.clearData();
    this._auth.isLoggedIn()
      .then(isLogged => {
          if (!isLogged) {
            this.router.navigate(['auth/login']);
          }
      });
  }

  ngOnDestroy(): void {
    this.authNoticeService.setNotice(null);
    this.loading = false;
  }

  ngAfterViewInit(): void {
    this.splahScreenService.hide();
  }

  login(): void {
		this.loading = true;
      this.router.navigate(['auth/login']);
  }

  getPageBackground() {
		return `url(${this.backgroundPage})`;
	}

}
